import createQuoteReducer from './createQuote';
import opportunityReducer from './opportunity';
import quoteActionsReducer from './quoteActions';
import ratingDetailsReducer from './ratings';
import compensationReducer from './compensation';
import quoteSearchReducer from './quoteSearch';

export default {
  quoteForm: createQuoteReducer,
  opportunity: opportunityReducer,
  quoteActions: quoteActionsReducer,
  ratingDetails: ratingDetailsReducer,
  compensation: compensationReducer,
  quoteSearch: quoteSearchReducer
};
